import React, { useEffect, useState } from 'react'
import useSWR from 'swr'
import { useWeb3React } from '@web3-react/core'
import {
  getStakingCoolDown,
  getStakingCoolDownRemainSeconds,
  getRageExitPreview,
} from '~/apis'
import {
  ForceRedeem,
  LonNoticeBeforeRedeem,
  LonUnlockCountDown,
  RedeemLonDeposit,
} from './components'
import { MODAL_TYPES } from './types'
import { useGA, useUpdaterChainId } from '~/hooks'

const UnlockDeposit: React.FC<{
  onClose: () => void
  onComplete: () => void
}> = ({ onClose, onComplete }) => {
  const chainId = useUpdaterChainId()
  const [modalType, setModalType] = useState<MODAL_TYPES>()
  const { trackClick } = useGA()

  const { account } = useWeb3React()
  const { data: coolDown } = useSWR(
    ['getStakingCoolDown', chainId, account],
    () => getStakingCoolDown(chainId, account),
  )
  const { data: remainingSeconds } = useSWR(
    ['getStakingCoolDownRemainSeconds', chainId, account],
    () => getStakingCoolDownRemainSeconds(chainId, account),
    { refreshInterval: 1000 },
  )
  const { data: rageExitPreview } = useSWR(
    ['getRageExitPreview', chainId, account],
    () => getRageExitPreview(chainId, account),
  )

  useEffect(() => {
    if (modalType === undefined && coolDown !== undefined) {
      setModalType(
        coolDown
          ? MODAL_TYPES.LON_UNLOCK_COUNT_DOWN_MODAL
          : MODAL_TYPES.LON_REDEEM_NOTICE_MODAL,
      )
    }
  }, [coolDown, modalType])

  return (
    <div className="content-container">
      {modalType === MODAL_TYPES.LON_REDEEM_NOTICE_MODAL && (
        <LonNoticeBeforeRedeem onComplete={onComplete} />
      )}
      {modalType === MODAL_TYPES.LON_UNLOCK_COUNT_DOWN_MODAL && (
        <LonUnlockCountDown
          onCloseModal={onClose}
          onClickRedeem={() => {
            setModalType(
              remainingSeconds
                ? MODAL_TYPES.LON_FORCE_REDEEM_MODAL
                : MODAL_TYPES.REDEEM_LON_DEPOSIT_MODAL,
            )
          }}
        />
      )}
      {modalType === MODAL_TYPES.LON_FORCE_REDEEM_MODAL && (
        <ForceRedeem
          onCloseDepositModal={onClose}
          onConfirmRedeemClick={() => {
            trackClick('webtl_staking_mandatory')
            setModalType(MODAL_TYPES.REDEEM_LON_DEPOSIT_MODAL)
          }}
        />
      )}
      {modalType === MODAL_TYPES.REDEEM_LON_DEPOSIT_MODAL && (
        <RedeemLonDeposit
          onComplete={onComplete}
          rageExitPreview={rageExitPreview}
          remainingSeconds={remainingSeconds}
        />
      )}
    </div>
  )
}

export default UnlockDeposit
